import React, { useEffect } from "react";
import SearchBar from "material-ui-search-bar";
import Select from "react-select";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PoolSearchTable from "./PoolSearchTable";
import CircularProgress from "@material-ui/core/CircularProgress";
import SiteSearchTable from "./SiteSearchTable";
import RangeSearchTable from "./RangeSearchTable";
import EndpointSearchTable from "./EndpointSearchTable";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import { fetchWithToken } from "../../../apiUtils";

const useStyles = makeStyles({
  table: {
    marginTop: 45,
  },
  loading: {
    marginTop: "5%",
    marginLeft: "50%",
  },
  card: {
    textAlign: "center",
    width: "500px",
    marginTop: "5%",
    marginLeft: "33%",
  },
});

const SearchResult = (props) => {
  const classes = useStyles();
  const { authObj } = props;
  let { searchBy, searchVal } = useParams();

  const getSearchArray = () => {
    let searchArray = searchVal.split(" ").filter((s) => s.trim().length > 0);
    if (searchArray.length > 1) {
      searchArray.map((e, i) => {
        if (e.length < 2) {
          searchArray.push(searchArray[i - 1] + " " + searchArray[i]);
          if (searchArray.length > i + 2)
            searchArray.push(searchArray[i] + " " + searchArray[i + 1]);
        }
      });
      searchArray = searchArray.filter((s) => s.trim().length > 2);
    }
    return searchArray;
  };

  console.log(getSearchArray());

  const [siteObj, setSiteObj] = useState({
    data: [],
    loading: true,
  });
  const [poolObj, setPoolObj] = useState({
    data: [],
    loading: true,
  });
  const [rangeObj, setRangeObj] = useState({
    data: [],
    loading: true,
  });
  const [endpointlObj, setEndpointObj] = useState({
    data: [],
    loading: true,
  });

  useEffect(() => {
    fetchWithToken("api/Sites")
      .then((res) => res.json())
      .then((data) => setSiteObj({ data: data, loading: false }));
    fetchWithToken("api/Pools")
      .then((res) => res.json())
      .then((data) => setPoolObj({ data: data, loading: false }));
    fetchWithToken("api/Ranges")
      .then((res) => res.json())
      .then((data) => setRangeObj({ data: data, loading: false }));
    fetchWithToken("api/TeamsEndpoints")
      .then((res) => res.json())
      .then((data) => setEndpointObj({ data: data, loading: false }));
  }, []);

  const FilterSites = () => {
    let filteredRows = [];
    getSearchArray().map((val) => {
      filteredRows = filteredRows.concat(
        siteObj.data.filter((row) => {
          var id = row.id.toString().toLowerCase().includes(val.toLowerCase());
          var dns =
            row.dnsSiteCode == null
              ? false
              : row.dnsSiteCode.toLowerCase().includes(val.toLowerCase());
          var name = row.name.toLowerCase().includes(val.toLowerCase());
          var country = row.country.toLowerCase().includes(val.toLowerCase());
          var state = row.state.toLowerCase().includes(val.toLowerCase());
          var city = row.city.toLowerCase().includes(val.toLowerCase());
          let results = id || dns || name || country || state || city;
          if (row.secondarySites && row.secondarySites.length > 0) {
            var sSiteId = false;
            var sSiteName = false;
            row.secondarySites.forEach((sSite) => {
              if (
                sSite.id.toString().toLowerCase().includes(val.toLowerCase())
              ) {
                sSiteId = true;
                return;
              }
              if (
                sSite.name.toString().toLowerCase().includes(val.toLowerCase())
              ) {
                sSiteName = true;
                return;
              }
            });
            results = results || sSiteId || sSiteName;
          }
          return results;
        })
      );
    });
    return Array.from(new Set(filteredRows));
  };

  const FilterPools = () => {
    let filteredRows = [];
    getSearchArray().map((val) => {
      filteredRows = filteredRows.concat(
        poolObj.data.filter((row) => {
          var name = row.name.toLowerCase().includes(val.toLowerCase());
          var description =
            row.description == null
              ? false
              : row.description.toLowerCase().includes(val.toLowerCase());
          var siteId = row.siteId
            .toString()
            .toLowerCase()
            .includes(val.toLowerCase());
          var siteName = row.siteName.toLowerCase().includes(val.toLowerCase());
          var dns =
            row.dnsSiteCode == null
              ? false
              : row.dnsSiteCode.toLowerCase().includes(val.toLowerCase());
          let results = name + description + siteId + siteName + dns;
          return results;
        })
      );
    });
    return Array.from(new Set(filteredRows));
  };

  const FilterRanges = () => {
    let filteredRows = [];
    getSearchArray().map((val) => {
      filteredRows = filteredRows.concat(
        rangeObj.data.filter((row) => {
          var pool = row.name.toLowerCase().includes(val.toLowerCase());
          var start =
            row.startNumber.toString().indexOf(val.toLowerCase()) > -1;
          var end = row.endNumber.toString().indexOf(val.toLowerCase()) > -1;
          let results = pool + start + end;
          return results;
        })
      );
    });
    return Array.from(new Set(filteredRows));
  };

  const FilterEndpoints = () => {
    let filteredRows = [];
    getSearchArray().map((val) => {
      filteredRows = filteredRows.concat(
        endpointlObj.data.filter((row) => {
          var number = row.did.toString().indexOf(val.toLowerCase()) > -1;
          var gmid =
            row.gmid == null
              ? false
              : row.gmid.toLowerCase().includes(val.toLowerCase());
          var comment =
            row.statusComment == null
              ? false
              : row.statusComment.toLowerCase().includes(val.toLowerCase());
          var name =
            row.displayName == null
              ? false
              : row.displayName
                  .toString()
                  .toLowerCase()
                  .includes(val.toLowerCase());
          var dialPlan =
            row.dialPlan == null
              ? false
              : row.dialPlan
                  .toString()
                  .toLowerCase()
                  .includes(val.toLowerCase());
          var voicePolicy =
            row.voicePolicy == null
              ? false
              : row.voicePolicy
                  .toString()
                  .toLowerCase()
                  .includes(val.toLowerCase());
          let results = number + gmid + comment + name + dialPlan + voicePolicy;
          return results;
        })
      );
    });
    return Array.from(new Set(filteredRows));
  };
  console.log((siteObj.loading, siteObj.data.length));
  console.log((poolObj.loading, poolObj.data.length));
  console.log((rangeObj.loading, rangeObj.data.length));
  console.log((endpointlObj.loading, endpointlObj.data.length));

  return (
    <>
      {searchBy == "all" &&
      siteObj.loading == false &&
      FilterSites().length < 1 &&
      poolObj.loading == false &&
      FilterPools().length < 1 &&
      rangeObj.loading == false &&
      FilterRanges().length < 1 &&
      endpointlObj.loading == false &&
      FilterEndpoints().length < 1 ? (
        <NoResultCard title={"All"} />
      ) : (
        <>
          {searchBy == "all" || searchBy == "sites" ? (
            <>
              {siteObj.loading ? (
                <div className={classes.loading}>
                  <CircularProgress />
                  <p style={{ marginLeft: "-25px" }}>Loading Sites</p>
                </div>
              ) : (
                <>
                  {FilterSites().length > 0 ? (
                    <div className={classes.table}>
                      <SiteSearchTable
                        data={FilterSites()}
                        title={"Sites"}
                        authObj={authObj}
                      />
                    </div>
                  ) : searchBy == "sites" ? (
                    <NoResultCard title={"Sites"} />
                  ) : null}
                </>
              )}
            </>
          ) : null}
          {searchBy == "all" || searchBy == "pools" ? (
            <>
              {poolObj.loading ? (
                <div className={classes.loading}>
                  <CircularProgress />
                  <p style={{ marginLeft: "-25px" }}>Loading Pools</p>
                </div>
              ) : (
                <>
                  {FilterPools().length > 0 ? (
                    <div className={classes.table}>
                      <PoolSearchTable
                        data={FilterPools()}
                        title={"Pools"}
                        authObj={authObj}
                      />
                    </div>
                  ) : searchBy == "pools" ? (
                    <NoResultCard title={"Pools"} />
                  ) : null}
                </>
              )}
            </>
          ) : null}
          {searchBy == "all" || searchBy == "ranges" ? (
            <>
              {rangeObj.loading ? (
                <div className={classes.loading}>
                  <CircularProgress />
                  <p style={{ marginLeft: "-25px" }}>Loading Ranges</p>
                </div>
              ) : (
                <>
                  {FilterRanges().length > 0 ? (
                    <div className={classes.table}>
                      <RangeSearchTable
                        data={FilterRanges()}
                        title={"Ranges"}
                        authObj={authObj}
                      />
                    </div>
                  ) : searchBy == "ranges" ? (
                    <NoResultCard title={"Ranges"} />
                  ) : null}
                </>
              )}
            </>
          ) : null}
          {searchBy == "all" || searchBy == "endpoints" ? (
            <>
              {endpointlObj.loading ? (
                <div className={classes.loading}>
                  <CircularProgress />
                  <p style={{ marginLeft: "-30px" }}>Loading Endpoints</p>
                </div>
              ) : (
                <>
                  {FilterEndpoints().length > 0 ? (
                    <div className={classes.table}>
                      <EndpointSearchTable
                        data={FilterEndpoints()}
                        title={"Endpoints"}
                        authObj={authObj}
                      />
                    </div>
                  ) : searchBy == "endpoints" ? (
                    <NoResultCard title={"Endpoints"} />
                  ) : null}
                </>
              )}
            </>
          ) : null}
        </>
      )}
    </>
  );
};

const NoResultCard = (props) => {
  const classes = useStyles();
  const { title } = props;

  return (
    <div className={classes.background}>
      <Card className={classes.card}>
        <div style={{ margin: "25px" }}>
          <h3>No Results In {title}</h3>
        </div>
      </Card>
    </div>
  );
};

export default SearchResult;
